import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';

import { FeatureName } from '__generated__/GQL';
import useCanCompanyUserAccessFeature from 'common/hooks/useCanCompanyUserAccessFeature';
import useFeatureFlagsSwitcher from 'common/hooks/useFeatureFlagsSwitcher';
import { PaymentCardList } from 'features/PaymentCards/pages/PaymentCardList';
import { PaymentCardsListFiltersProvider } from 'features/PaymentCards/pages/PaymentCardList/components/PaymentCardsListFiltersProvider';

import { FakeTemporaryVirtualPaymentCardIdContextProvider } from './context';
import PaymentCardListLegacy from './pages/PaymentCardListLegacy';
import PaymentCardOrder from './pages/PaymentCardOrder';
import PhysicalCardOrder from './pages/PaymentCardOrder/PhysicalCardOrder';
import VirtualCardOrder from './pages/PaymentCardOrder/VirtualCardOrder';
import PaymentCardRenewal from './pages/PaymentCardRenewal';
import RequestNewCard from './pages/RequestNewCard';
import * as routes from './routes';

const PaymentCards: FC = () => {
  const { canAccessFeature } = useCanCompanyUserAccessFeature();
  const { featureFlags } = useFeatureFlagsSwitcher();

  const canAccesFeaturePaymentCards = canAccessFeature({
    name: FeatureName.Paymentcards,
  });

  return (
    <Switch>
      {canAccessFeature({ name: FeatureName.PaymentcardsOrder }) ? (
        <Route component={PaymentCardOrder} path={routes.orderNew} />
      ) : null}

      <Route component={PhysicalCardOrder} path={routes.orderNewPhysical} />
      <Route component={VirtualCardOrder} path={routes.orderNewVirtual} />
      <Route
        component={VirtualCardOrder}
        path={routes.orderNewVirtualTemporary}
      />
      <Route component={RequestNewCard} path={routes.requestNew} />

      <Route component={PaymentCardRenewal} path={routes.renewal} />

      {featureFlags.enableNewCardFlowManagement &&
      canAccesFeaturePaymentCards ? (
        <PaymentCardsListFiltersProvider
          canViewCompanyCards={canAccesFeaturePaymentCards}
        >
          <Route component={PaymentCardList} path={routes.paymentCard} />
        </PaymentCardsListFiltersProvider>
      ) : (
        <FakeTemporaryVirtualPaymentCardIdContextProvider>
          <Route component={PaymentCardListLegacy} path={routes.card} />
        </FakeTemporaryVirtualPaymentCardIdContextProvider>
      )}
    </Switch>
  );
};

export default PaymentCards;
